/**
 * Created by shinan.chen on 2021/12/25.
 */
import { getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface IFinanceRecord {
    id: number,
    name: string,
    value: string,
    typeId: number,
    typeName: string,
    payWay: string,
    payWayName: string,
    income: boolean,
    incomeName: string,
    storeId: number,
    recordTime: Date,
    createdBy: string,
    children: IFinanceRecord[]
}

export const listFinanceRecords = () =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/list_all`,
    });

export const createFinanceRecord = (data: IFinanceRecord) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/create`,
        data
    });

export const updateFinanceRecord = (data: IFinanceRecord) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/update`,
        data
    });

export const deleteFinanceRecord = (id: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/delete?id=${id}`
    });

export const enableFinanceRecord = (id: number, enable: boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/enable?id=${id}&&enable=${enable}`
    });

export const pageFinanceRecords = (pageNum: number, pageSize: number, storeIds: any, keyword: string) =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/page?pageNum=${pageNum}&&storeIds=${storeIds}&&pageSize=${pageSize}&&keyword=` + encodeURI(keyword),
    });

export interface IFinanceRecordType {
    id: number,
    name: string,
    income: boolean,
}

export const createFinanceRecordType = (data: IFinanceRecordType) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/type/create`,
        data
    });

export const updateFinanceRecordType = (data: IFinanceRecordType) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/type/update`,
        data
    });

export const deleteFinanceRecordType = (id: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/type/delete?id=${id}`
    });

export const enableFinanceRecordType = (id: number, enable: boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/finance_record/type/enable?id=${id}&&enable=${enable}`
    });

export const pageFinanceRecordTypes = (pageNum: number, pageSize: number, keyword: string) =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/type/page?pageNum=${pageNum}&&pageSize=${pageSize}&&keyword=` + encodeURI(keyword),
    });

export const listFinanceRecordTypes = () =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/type/list_all`,
    });

export const listFinanceRecordTypesByIncome = (income: boolean) =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/type/list_by_income?income=` + income,
    });

export interface IPayWay {
    name: string,
    value: string,
}

export const listPayWay = () =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/list_pay_way`,
    });


export interface IFinanceDataView {
    timeGroups: IFinanceTimeGroup[],
    incomeTypeGroups: IFinanceIncomeTypeGroup[],
    outcomeTypeGroups: IFinanceOutcomeTypeGroup[],
    totalNetProfits: string,
    totalIncome: string,
    totalOutcome: string,
    totalRecordCount: number,
}

export interface IFinanceTimeGroup {
    month: string,
    netProfits: string,
    income: string,
    outcome: string,
    recordCount: number,
    financeRecords: IFinanceRecordData[],
}
export interface IFinanceIncomeTypeGroup {
    name: string,
    income: string,
    recordCount: number,
    financeRecords: IFinanceRecordData[],
}
export interface IFinanceOutcomeTypeGroup {
    name: string,
    outcome: string,
    recordCount: number,
    financeRecords: IFinanceRecordData[],
}
export interface IFinanceRecordData {
    id:number,
    messageName: string,
    messageValue: string,
}

export const getDataView = (startDate: any, endDate: any, storeId: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/finance_record/data?` + (startDate ? `&startDate=${startDate}` : ``) + (endDate ? `&endDate=${endDate}` : ``) + (storeId ? `&storeId=${storeId}` : ``),
    });